var map = {
	"./t1-1.png": "9404",
	"./t1-2.png": "5f8f",
	"./t1-3.png": "27a6",
	"./t1-duo-1.png": "59c6",
	"./t1-duo-2.png": "9c23",
	"./t2-1.png": "878b",
	"./t2-2.png": "1ccc",
	"./t2-3.png": "d787",
	"./t2-4.png": "b3e7",
	"./t3-bronze.png": "0a00",
	"./t3-gold.png": "400d",
	"./t3-silver.png": "5240"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f9d4";